import addressSchemaMapper from './addressSchemaMapper';
import googleApiMapper from './googleApiMapper';
import paymentOptionsMapper from './transaction/paymentOptionsMapper';
import salonMapper from './transaction/salonMapper';
import cartItemsMapper from './transaction/cartItemsMapper';
import mpPSEPaymentOptionsMapper from './mpPSEPaymentOptionsMapper';
import deliveryMethodsMapper from './transaction/deliveryMethodsMapper';
import melissaApiMapper from './melissaApiMapper';
import shipOptionsMapper from './transaction/shipOptionsMapper';
import addressMapper from './transaction/addressMapper';
import deliveryOptionsMapper from './transaction/deliveryOptionsMapper';
import deliveryOptionsMapper2 from './transaction/deliveryOptionsMapper2';
import donationApiMapper from './donationApiMapper';
import clickAndCollectDataMapper from './clickAndCollectDataMapper';

const DataMappings = {
  addressMapper,
  addressSchemaMapper,
  cartItemsMapper,
  clickAndCollectDataMapper,
  deliveryMethodsMapper,
  deliveryOptionsMapper,
  deliveryOptionsMapper2,
  donationApiMapper,
  googleApiMapper,
  melissaApiMapper,
  mpPSEPaymentOptionsMapper,
  paymentOptionsMapper,
  salonMapper,
  shipOptionsMapper,
};

export default DataMappings;
